<template>
  <Modal
      id="OrderEdit"
      width="50%"
      :open="visible"
      @cancel="visible = false"
      @ok="visible = false"

      :title="$t('public.consumeType.2')"
  >
    <template #footer>
      <Button key="submit1" type="primary" @click="handleOk(false)">{{$t('order.name.cancel')}}</Button>
      <Button key="submit2" type="primary" :loading="loading" @click="handleOk(true)">{{$t('order.name.cancelAndRefund')}}</Button>
      <Button key="back" @click="handleCancel">{{$t('public.name.cancel')}}</Button>
    </template>

    <Row justify="center" >
      <Col span="18">
        <Row>
          <Col span="24">
            <Form
                ref="orderForm"
                :model="form"
                layout="vertical"
                :rules="validateRules"
            >
              <Row justify="space-around">

                <Col span="10">
                  <FormItem :label="$t('order.table.id_ord')" name="idOrd">
                    <Input
                        v-model:value="form.idOrd"
                        :placeholder="$t('order.validate.id_ord')"
                        disabled
                    />
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('user.table.account')" name="account">
                    <Input v-model:value="form.account" disabled/>
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('order.table.amount')" name="amount">
                    <InputNumber
                        v-model:value="form.amount"
                        :placeholder="$t('order.validate.amount')"
                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                        :min="0" :step="0.01"
                        style="width: 100%"
                        disabled
                    />
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('order.table.paymentStatus')" name="status">
                    <Select
                        v-model:value="form.paymentStatus"
                        :placeholder="$t('order.validate.status')"
                        :options="statusList"
                        :dropdownStyle="{ zIndex: 9999999950 }"
                        disabled
                    >
                    </Select>
                  </FormItem>
                </Col>
                <Col span="22">
                  <FormItem :label="$t('public.name.remark')" name="remark">
                    <Textarea
                        v-model:value="form.remark"
                        :placeholder="$t('employee.validate.required.remark')"
                        :auto-size="{ minRows: 5, maxRows: 10 }"
                        showCount
                    />
                  </FormItem>
                </Col>

              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>
<script>
export default {
  name: "CancelOrderEdit",
}
</script>
<script setup>
import {
  Modal,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  Textarea,
  InputNumber,
  message,
  Select,
  Button,
  Divider
} from "ant-design-vue";
import {
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import {OrderCancelOrderById} from "@/api/order";
import {createVNode, reactive, ref, toRefs} from "vue";
import {useI18n} from "vue-i18n"
import {useStore} from "vuex";

const store = useStore()
const i18n = useI18n()
const emits = defineEmits(['updateList'])

let loading = ref(false)
let visible = ref(false)
let actionType = ref("")
let title = ref("")

const orderForm = ref()

const typeList = [
  {value: 1, label: i18n.t("public.chargeType.0")},
  {value: 2,label: i18n.t("public.chargeType.1")},
  {value: 3, label: i18n.t("public.chargeType.2")}
]
const statusList = [
  {value: 0, label: i18n.t("order.paymentStatus.0")},
  {value: 1, label: i18n.t("order.paymentStatus.1")},
  {value: 2, label: i18n.t("order.paymentStatus.2")},
  {value: 3, label: i18n.t("order.paymentStatus.3")},
  {value: 4, label: i18n.t("order.paymentStatus.4")},
  {value: 5, label: i18n.t("order.paymentStatus.5")},
]
const payTypeList = [{value: 1, label: 'Online Pay'}, {value: 2, label: 'Balance'}]
const validateRules = {
  remark: [
    {
      required: true,
      message: i18n.t("employee.validate.required.remark"),
      trigger: "change",
    },
  ],
}

const data = reactive({
  form: {},
})
const {form} = toRefs(data)

function handleCancel() {
  visible.value = false
}

async function editShow(obj) {
  _resetData();
  actionType.value = "edit";
  form.value = JSON.parse(JSON.stringify(obj));
  visible.value = true;
}

function handleOk(isRefund) {
  orderForm.value.validate().then(() => {
    Modal.confirm({
      title: i18n.t("public.name.are_you_sure_operate") + "?",
      content: i18n.t("public.name.operate_remind") + "！",
      icon: createVNode(ExclamationCircleOutlined),
      okText: i18n.t("public.name.yes"),
      okType: "danger",
      cancelText: i18n.t("public.name.no"),
      onOk: () => {
        let api = new OrderCancelOrderById();
        api.post({...form.value, isRefund: isRefund}).then((response) => {
          if (0 === parseInt(response.data.code)) {
            message.success(i18n.t("succeedMsg.0"));
            emits("updateList", response.data.data);
            visible.value = false;
          } else {
            if(response.data.code !== undefined){message.error(i18n.t("errorMsg." + response.data.code));}
          }
        });
      },
    });
  }).catch(() => {});
}

function _resetData() {
  form.value = {};
}

defineExpose({
  editShow
})
</script>
